import { useCallback, useState } from 'react';

import { apiPaths } from 'src/services/api/apiPaths';
import { useUserContext } from 'src/components/app/context/UserContext';
import ReportHeader from 'src/components/report/ReportHeader';
import { CustomReportTable } from 'src/components/report/ReportTable';

export const initialAdvancedSearchFilters = {
  file_type: '',
  report_type: '',
  date_start: '',
  date_end: '',
};
Object.freeze(initialAdvancedSearchFilters);

const ReportOverview = () => {
  const { user } = useUserContext();
  const [advancedSearchFilters, setAdvancedSearchFilters] = useState({
    ...initialAdvancedSearchFilters,
  });
  const [searchQuery, setSearchQuery] = useState<string>('');
  const searchEndpoint = apiPaths.GET_CUSTOM_REPORTS_QUERY_SEARCH;

  const handleAdvancedSearchFilterChange = useCallback(
    (key: any, value: any) => {
      setAdvancedSearchFilters((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    },
    [],
  );

  const handleQueryChange = (queryString: string | null) => {
    if (queryString === null) {
      return;
    }
    setSearchQuery(queryString);
  };

  return (
    <>
      <ReportHeader
        reportOwnerName={user ? `${user.first_name} ${user.last_name}` : ''}
        reportOwnerId=""
        showCustomReports
      />

      <CustomReportTable
        advancedSearchFilters={advancedSearchFilters}
        searchUrl={
          searchQuery ? `${searchEndpoint}${searchQuery || ''}` : undefined
        }
        handleAdvancedSearchFilterChange={handleAdvancedSearchFilterChange}
        handleSearch={handleQueryChange}
        reports={[]}
      />
    </>
  );
};

export default ReportOverview;
